<template>
  <v-container :class="$vuetify.breakpoint.smAndDown ? 'px-2 pt-2' : ''">
    <h1 class="text-center">Link Protection</h1>
    <p class="text-center mb-6">
      Löscht automatisch Chat-Nachrichten mit Links und warnt den User. Whitelist-Domains
      und Ausnahmen (VIP/Mod/Sub) werden dabei nicht angerührt.
    </p>

    <v-row>
      <v-col cols="12" md="8" offset-md="2">
        <v-card outlined class="mb-4">
          <v-card-text class="d-flex flex-wrap justify-space-between align-center">
            <div class="mr-2">
              <div class="font-weight-medium">Link-Schutz aktiv</div>
              <div class="caption grey--text">Schaltet die komplette Funktion an oder aus.</div>
            </div>
            <v-switch
              v-if="enabledItem"
              v-model="enabledItem.var_content[0]"
              color="success"
              :true-value="'1'"
              :false-value="'0'"
              hide-details
              inset
              class="flex-grow-0 mt-2 mt-sm-0"
              @change="saveSwitch(enabledItem)"
            ></v-switch>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-4">
          <v-card-text>
            <div class="font-weight-medium mb-1">Stufen-System</div>
            <div class="caption grey--text mb-3">
              Jede Stufe hat einen eigenen Timeout-Wert. 0 Sekunden = nur löschen + Warnung, kein Timeout.
            </div>
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-if="timeoutItem1"
                  v-model.number="timeoutValue1"
                  label="Timeout 1. Verstoß (Sekunden)"
                  type="number"
                  min="0"
                  outlined
                  dense
                  hide-details
                  @change="saveNumberField(timeoutItem1, timeoutValue1, (v) => { timeoutValue1 = v; })"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-if="timeoutItem"
                  v-model.number="timeoutValue"
                  label="Timeout 2. Verstoß (Sekunden)"
                  type="number"
                  min="0"
                  outlined
                  dense
                  hide-details
                  @change="saveNumberField(timeoutItem, timeoutValue, (v) => { timeoutValue = v; })"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-if="timeoutItem3"
                  v-model.number="timeoutValue3"
                  label="Timeout ab 3. Verstoß (Sekunden)"
                  type="number"
                  min="0"
                  outlined
                  dense
                  hide-details
                  @change="saveNumberField(timeoutItem3, timeoutValue3, (v) => { timeoutValue3 = v; })"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-if="strikeResetItem"
                  v-model.number="strikeResetValue"
                  label="Verstöße zurücksetzen nach (Minuten, 0 = nie automatisch)"
                  type="number"
                  min="0"
                  outlined
                  dense
                  hide-details
                  @change="saveNumberField(strikeResetItem, strikeResetValue, (v) => { strikeResetValue = v; })"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-4">
          <v-card-text>
            <div class="font-weight-medium mb-2">Ausnahmen</div>
            <div class="d-flex flex-wrap justify-space-between align-center mb-2" v-if="bypassVipModItem">
              <span class="mr-2">VIPs &amp; Moderatoren dürfen Links posten</span>
              <v-switch
                v-model="bypassVipModItem.var_content[0]"
                color="success"
                :true-value="'1'"
                :false-value="'0'"
                hide-details
                inset
                class="flex-grow-0 mt-2 mt-sm-0"
                @change="saveSwitch(bypassVipModItem)"
              ></v-switch>
            </div>
            <div class="d-flex flex-wrap justify-space-between align-center" v-if="bypassSubItem">
              <span class="mr-2">Abonnenten dürfen Links posten</span>
              <v-switch
                v-model="bypassSubItem.var_content[0]"
                color="success"
                :true-value="'1'"
                :false-value="'0'"
                hide-details
                inset
                class="flex-grow-0 mt-2 mt-sm-0"
                @change="saveSwitch(bypassSubItem)"
              ></v-switch>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined>
          <v-card-text>
            <div class="font-weight-medium mb-1">Whitelist-Domains</div>
            <div class="caption grey--text mb-3">
              Links zu diesen Domains werden nie gelöscht (z.B. Spotify, Steam).
            </div>
            <v-row dense>
              <v-col cols="12" sm="9">
                <v-text-field
                  v-model="newDomain"
                  label="Domain, z.B. example.com"
                  hide-details
                  dense
                  @keydown.enter="addDomain"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-btn color="primary" block @click="addDomain" :disabled="!newDomain">Hinzufügen</v-btn>
              </v-col>
            </v-row>
            <v-chip-group class="mt-3" v-if="whitelistItem">
              <v-chip
                v-for="domain in whitelistItem.var_content"
                :key="domain"
                close
                close-icon="mdi-delete"
                @click:close="removeDomain(domain)"
              >
                {{ domain }}
              </v-chip>
            </v-chip-group>
            <v-alert v-if="whitelistItem && whitelistItem.var_content.length === 0" type="info" dense class="mt-2">
              Keine Domains auf der Whitelist.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="saved" timeout="2000" color="green">
      Gespeichert!
    </v-snackbar>
  </v-container>
</template>

<script>
import BackendService from '@/services/BackendService';

export default {
  name: 'LinkProtectionSettings',
  data() {
    return {
      settings: [],
      newDomain: '',
      timeoutValue1: 0,
      timeoutValue: 0,
      timeoutValue3: 0,
      strikeResetValue: 30,
      saved: false,
    };
  },
  computed: {
    enabledItem() {
      return this.settings.find((item) => item.var_name === 'link_protection_enabled');
    },
    timeoutItem1() {
      return this.settings.find((item) => item.var_name === 'link_protection_timeout_sec_1');
    },
    timeoutItem() {
      return this.settings.find((item) => item.var_name === 'link_protection_timeout_sec');
    },
    timeoutItem3() {
      return this.settings.find((item) => item.var_name === 'link_protection_timeout_sec_3');
    },
    strikeResetItem() {
      return this.settings.find((item) => item.var_name === 'link_protection_strike_reset_min');
    },
    bypassVipModItem() {
      return this.settings.find((item) => item.var_name === 'link_protection_bypass_vip_mod');
    },
    bypassSubItem() {
      return this.settings.find((item) => item.var_name === 'link_protection_bypass_sub');
    },
    whitelistItem() {
      return this.settings.find((item) => item.var_name === 'link_protection_whitelist');
    },
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    loadSettings() {
      BackendService.loadCommandSettings({ variant: 1 }).then((data) => {
        this.settings = data.data.filter((item) => item.var_name.startsWith('link_protection_'));
        if (this.timeoutItem1) this.timeoutValue1 = Number(this.timeoutItem1.var_content[0]) || 0;
        if (this.timeoutItem) this.timeoutValue = Number(this.timeoutItem.var_content[0]) || 0;
        if (this.timeoutItem3) this.timeoutValue3 = Number(this.timeoutItem3.var_content[0]) || 0;
        if (this.strikeResetItem) this.strikeResetValue = Number(this.strikeResetItem.var_content[0]) || 0;
      });
    },
    saveSwitch(item) {
      const newState = Number(item.var_content[0]) === 0 ? 0 : 1;
      BackendService.saveSwitchStateVariable({
        var_content: newState,
        id1: item.id,
        variant: 1,
      }).then((data) => {
        this.settings = data.data.filter((entry) => entry.var_name.startsWith('link_protection_'));
        this.saved = true;
      });
    },
    saveNumberField(item, currentValue, applyValue) {
      if (!item) return;
      const value = Math.max(0, Number(currentValue) || 0);
      applyValue(value);
      BackendService.saveCommandSettings({
        id: item.id,
        var_name: item.var_name,
        var_content: String(value),
        var_type: item.var_type,
        description: item.description,
        variant: 1,
      }).then((data) => {
        this.settings = data.data.filter((entry) => entry.var_name.startsWith('link_protection_'));
        this.saved = true;
      });
    },
    saveWhitelist(domains) {
      BackendService.saveCommandSettings({
        id: this.whitelistItem.id,
        var_name: this.whitelistItem.var_name,
        var_content: domains,
        var_type: this.whitelistItem.var_type,
        description: this.whitelistItem.description,
        variant: 1,
      }).then((data) => {
        this.settings = data.data.filter((entry) => entry.var_name.startsWith('link_protection_'));
        this.saved = true;
      });
    },
    addDomain() {
      if (!this.newDomain || !this.whitelistItem) return;
      const domain = this.newDomain.trim().toLowerCase();
      if (!domain || this.whitelistItem.var_content.includes(domain)) {
        this.newDomain = '';
        return;
      }
      this.saveWhitelist([...this.whitelistItem.var_content, domain]);
      this.newDomain = '';
    },
    removeDomain(domain) {
      if (!this.whitelistItem) return;
      this.saveWhitelist(this.whitelistItem.var_content.filter((item) => item !== domain));
    },
  },
};
</script>
